import { recordMapper } from "./record";

export const deleteRecordMapper = recordMapper;
